import { useState } from "react";
import { useAbschlussPin, useAbschlussPinNeu } from "../hooks/useLastschrift";
import { fehlertext } from "../lib/fehler";
import "../styles/lastschrift.css";

/**
 * Die Abschluss-PIN des offenen Angebots (Mig 167).
 *
 * Ohne sie kann der Kunde nicht verbindlich zustimmen — auch wer den Link aus
 * einer weitergeleiteten Mail hat. Deshalb gehört sie NICHT in die Mail: bei
 * der Besichtigung sagen, am Telefon nennen oder auf das ausgedruckte Angebot
 * schreiben. Verlegt der Kunde sie, kann er sich auf der Seite einen Code per
 * E-Mail schicken lassen — oder hier gibt es eine neue.
 */
export default function AbschlussPin({ vertragId }: { vertragId: string }) {
  const { data, error } = useAbschlussPin(vertragId);
  const neu = useAbschlussPinNeu(vertragId);
  const [armed, setArmed] = useState(false);

  if (error) return <p className="ls-fehler">{fehlertext(error) || "PIN nicht ladbar."}</p>;
  if (!data || data.abgeschlossen) return null;

  return (
    <div className="ls-pin">
      <div className="ls-pin-kopf">
        <span className="ls-pin-titel">Abschluss-PIN</span>
        <span className="ls-pin-wert">{data.pin.slice(0, 3)} {data.pin.slice(3)}</span>
        {data.gesperrt && <span className="ls-marke ls-rot">gesperrt</span>}
      </div>
      <p className="ls-text">
        Dem Kunden persönlich geben — bei der Besichtigung, am Telefon oder auf dem Ausdruck. Nie per Mail: ohne PIN
        kann niemand mit dem Link allein abschließen.
      </p>
      {!armed ? (
        <button type="button" className="pf-btn is-ghost is-small" onClick={() => setArmed(true)}>Neue PIN</button>
      ) : (
        <div className="ls-knoepfe">
          <span className="ls-text ls-frage">Die alte PIN gilt dann nicht mehr.</span>
          <button type="button" className="pf-btn is-small" disabled={neu.isPending}
            onClick={() => neu.mutate(undefined, { onSuccess: () => setArmed(false) })}>
            {neu.isPending ? "Erzeugt…" : "Ja, neue PIN"}
          </button>
          <button type="button" className="pf-btn is-ghost is-small" onClick={() => setArmed(false)}>Abbrechen</button>
        </div>
      )}
      {neu.error && <p className="ls-fehler">{fehlertext(neu.error)}</p>}
    </div>
  );
}
